import PropTypes from "prop-types";

const Badge = ({ status }) => {
  return (
    <span
      className={`px-3 py-1 text-sm font-semibold rounded-full ${
        status === "won"
          ? "inline-flex items-center rounded-md bg-green-50 px-2 m-2 py-1 text-xs font-medium text-green-700 ring-1 ring-green-600/20 ring-inset"
          : "inline-flex items-center rounded-md bg-red-50 px-2 m-2 py-1 text-xs font-medium text-red-700 ring-1 ring-red-600/10 ring-inset"
      }`}
    >
      {status === "won" ? "Won" : "Lost"}
    </span>
  );
};

// Prop Validation
Badge.propTypes = {
  status: PropTypes.oneOf(["won", "lost"]).isRequired,
};

export default Badge;
